import { VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { Platform, TouchableOpacity } from "react-native";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { CustomHeaderProps } from "./types";
import Routes from "@navigations/Routes";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import Logo from "@components/atoms/Logo";
import { navigate, goBack } from "@navigations/utils/RootNavigation";
import { DefaultTheme } from "styled-components/native";

const CustomHeader = ({ title, showLogo = false, icon }: CustomHeaderProps) => {
  const { typography, theme, user } = useScreenOptionsHooks();
  const { lightVDBLogo, settings } = useOrgSettingsSlice();

  return (
    <Overlay title={title}>
      {Platform.OS === "web" && (
        <Content>
          {showLogo ? (
            settings?.organization?.id === 1 ? (
              <VDBLogo source={lightVDBLogo} resizeMode="cover" />
            ) : (
              <Logo height={100} width={200} url={settings.logo_url} />
            )
          ) : (
            <VDBText
              color={theme["header-cont"]}
              type={typography["H2-M"]}
              allowFontScaling={false}
            >
              {title}
            </VDBText>
          )}
        </Content>
      )}
      <TouchableOpacity
        onPress={() =>
          theme.isLargeScreen && !user?.public_login
            ? navigate(Routes.OnboardingWeb)
            : goBack()
        }
        style={{ left: 15, position: "absolute" }}
      >
        <VDBIcon
          variant={IconsVariant.VDBCustom}
          name={icon ? icon : VDBIcons.CLOSE_CIRCLE}
          size={24}
          color={theme["header-cont"]}
        />
      </TouchableOpacity>
    </Overlay>
  );
};

export default CustomHeader;

const Overlay = styled.View<{
  title?: string;
}>`
  flex-direction: row;
  align-items: center;
  height: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isLargeScreen ? 112 : 56};
  background-color: ${({
    theme,
    title,
  }: {
    theme: DefaultTheme;
    title?: string;
  }) =>
    title ? theme["header-bg-static"] || theme["core-03"] : theme["core-03"]};
  ${({ theme }: { theme: DefaultTheme }) =>
    theme.isLargeScreen &&
    `
     justifyContent: "center",
  `};
`;

const Content = styled.View`
  flex: 1;
  align-items: center;
`;

const VDBLogo = styled.Image`
  height: 90px;
  width: 224px;
`;
